import { useTranslation } from "react-i18next";

function WizardStepIndicator({ currentStep }) {
	const { t } = useTranslation();
	const step1Done = currentStep > 1;

	return (
		<div className="add-member-wizard__wizard">
			<div
				className={`add-member-wizard__wstep ${currentStep === 1 ? "cur" : ""} ${step1Done ? "done" : ""}`}
			>
				<div className="add-member-wizard__wnum">
					{step1Done ? "✓" : "1"}
				</div>
				<span>{t("projects.members.wizard-step-select-user")}</span>
			</div>
			<div
				className={`add-member-wizard__wconn ${step1Done ? "done" : ""}`}
			/>
			<div
				className={`add-member-wizard__wstep ${currentStep === 2 ? "cur" : ""}`}
			>
				<div className="add-member-wizard__wnum">2</div>
				<span>{t("projects.members.wizard-step-set-permissions")}</span>
			</div>
		</div>
	);
}

export default WizardStepIndicator;
